<script setup lang="ts">
import { KsDialogRoot } from '@aschehoug/kloss-2'
</script>

<template>
  <KsDialogRoot class="dialog-root">
    <slot />
  </KsDialogRoot>
</template>
